import { useCallback, useEffect, useState } from 'react';
import {
  fetchPresupuestos,
  createPresupuesto,
  updatePresupuesto,
  togglePresupuestoStatus,
} from '../services/presupuestos';

export function usePresupuestosCrud() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMutating, setIsMutating] = useState(false);

  const cargar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await fetchPresupuestos();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const crear = useCallback(async (dePresupuesto) => {
    setIsMutating(true);
    try {
      return await createPresupuesto(dePresupuesto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  const actualizar = useCallback(async (cdPresupuesto, dePresupuesto) => {
    setIsMutating(true);
    try {
      return await updatePresupuesto(cdPresupuesto, dePresupuesto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  const toggleEstado = useCallback(async (cdPresupuesto) => {
    setIsMutating(true);
    try {
      return await togglePresupuestoStatus(cdPresupuesto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { items, isLoading, error, isMutating, cargar, crear, actualizar, toggleEstado };
}